import React, { Component } from 'react'
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import _kebabCase from 'lodash/kebabCase'
import { Bookmark } from 'react-feather'

import ColorCoding from '../utils/ColorCoding'
import Utils from '../utils/Utils'
import Licenses from '../resources/Licenses'
import BreadcrumbCard from '../utils/BreadcrumbCard'

class Acknowledgements extends Component {
    constructor(props) {
        super(props)
        this.breadcrumbs = [
            {
                title: Acknowledgements.getTitle(),
                active: true,
            }
        ]
        this.colorCoding = new ColorCoding({dark:true})
    }

    static getTitle() {
        return "Acknowledgements"
    }
    static getSearchTitle() {
        return Acknowledgements.getTitle()
    }
    static getLink() {
        return '/' + _kebabCase(Acknowledgements.getSearchTitle())
    }
    static getTags() {
        return []
    }
    static getNavIcon(className) {
        return <Bookmark className={ className } />
    }

    componentDidMount() {
        Utils.injectTwitterCardTags(Acknowledgements.getSearchTitle())
    }
    componentWillUnmount() {
        Utils.removeTwitterCardTags()
    }

    render() {
        const nonGithub = [
            {
                title: "GeoNames.org",
                link: "http://download.geonames.org/export/dump/",
                license: "CC BY 4.0",
                licenseLink: "https://creativecommons.org/licenses/by/4.0/",
            },
            {
                title: "IP to Country Database",
                link: "http://software77.net/geo-ip/",
                license: "DONATIONWARE",
                licenseLink: "https://software77.net/geo-ip/?license",
            }
        ]

        return (
            <BreadcrumbCard breadcrumbs={ this.breadcrumbs } noBorder={ true }>
                <Card>
                    <CardHeader><span><em>appler.dev</em> would not have been possible without these awesome projects!</span></CardHeader>
                    <CardContent>
                        <div id={"acknowledgements"} className={"grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2"}>
                            {Object.keys(Licenses).map((pckg) => {
                                const licenses = Licenses[pckg].licenses.replace(/[*()]/g,'').split(/ OR /g)
                                const repoUrl = Licenses[pckg].repository
                                return (
                                    <Card key={ _kebabCase(pckg) }>
                                        <CardContent className="p-3">
                                            <CardTitle>
                                                <a href={ repoUrl }>{ pckg }</a>
                                            </CardTitle>
                                            { licenses.map(license => {
                                                return <Badge key={license} className={'license ml-2 text-white'} style={{ backgroundColor: this.colorCoding.getColor(license) }}>{ license }</Badge>
                                            }) }
                                        </CardContent>
                                    </Card>
                                )
                            })}
                            {nonGithub.map(info => {
                                return (
                                    <Card key={ _kebabCase(info.title) }>
                                        <CardContent className="p-3">
                                            <CardTitle>
                                                <a href={ info.link }>{ info.title }</a>
                                            </CardTitle>
                                            <a href={ info.licenseLink }><Badge className={'license ml-2 text-white'} style={{ backgroundColor: this.colorCoding.getColor(info.license) }}>{ info.license }</Badge></a>
                                        </CardContent>
                                    </Card>
                                )
                            })}
                        </div>
                    </CardContent>
                </Card>
            </BreadcrumbCard>
        )
    }
}

export default Acknowledgements
